export enum SpaceAdminRoutes {
  index = '/:lang/admin',
  ALL = '/:lang/admin/*',
  login = '/:lang/admin/login',
  TwoFALogin = '/:lang/admin/2fa-login',
  TwoFASetup = '/:lang/admin/2fa-setup',
  FirstLogn = '/:lang/admin/first-logon/:userId?/:expires?/:signature?',
  Support = '/:lang/admin/support',
  PasswordReset = '/:lang/admin/login#pw-reset',
  SSOLoginProviders = '/:lang/admin/sso-login-providers',
  EmailNotVerified = '/:lang/admin/email-not-verified',
  EmailVerification = '/:lang/admin/email-verification/:userId?/:expires?/:signature/:token?/:survey_id?',
  Settings = '/:lang/admin/settings',
  Users = '/:lang/admin/users',
  ParticipantList = '/:lang/admin/participants-list',
  EmailTemplates = '/:lang/admin/email-templates',
  NewEmailTemplate = '/:lang/admin/email-templates/new',
  EditEmailTemplate = '/:lang/admin/email-templates/:id',

  Portal = '/:lang/admin/portal',
  CustomStyles = '/:lang/admin/custom-styles',
  Accounts = '/:lang/admin/accounts',
  ParticipantGroupTags = '/:lang/admin/participant-group-tags',

  SetupSurveyDocumentGroupsIndex = '/:lang/admin/setup/survey-document-groups',

}